import React,{ Component } from 'react';
import Sunburst from 'sunburst-chart';

import './SunburstChart.css';
/**
 * https://codesandbox.io/s/sunburst-d3-react-ioop1?from-embed=&file=/src/SunburstChart.tsx
 * https://nivo.rocks/sunburst/
 * https://www.npmjs.com/package/sunburst-chart
 * https://vasturiano.github.io/sunburst-chart/example/large-data/
 * https://plotly.com/javascript/sunburst-charts/
 * https://www.highcharts.com/docs/chart-and-series-types/sunburst-series
 */

interface Props{
    data: any

    width?: number
    height?: number
    color?: Function
    strokeColor?: Function
    tooltipContent?: Function
    excludeRoot?: boolean
    // centerRadius?: Function
    // radiusScaleExponent?: Function
    // color?: Function
}
interface State{
}


export default class SunburstChart extends Component<Props,State>{
    ref: any
    chart?: any


    constructor(props:Props){
        super(props);
        
        this.ref = React.createRef();
    }

    componentDidMount(){
        this.set_data();
    }

    componentDidUpdate(prevProps:Props){
        if(prevProps.data !== this.props.data){
            this.set_data();
        }
        if(prevProps.width !== this.props.width)
            this.chart?.width(this.props.width)
        if(prevProps.height !== this.props.height)
            this.chart?.height(this.props.height)
        if(prevProps.color !== this.props.color)
            this.chart?.color(this.props.color)
        if(prevProps.strokeColor !== this.props.strokeColor)
            this.chart?.strokeColor(this.props.strokeColor)
        if(prevProps.tooltipContent !== this.props.tooltipContent)
            this.chart?.tooltipContent(this.props.tooltipContent)
    }

    set_data = () =>{
        if(this.props.data && this.ref?.current){
            this.chart = Sunburst();
            this.chart?.data(this.props.data)(this.ref?.current)
                .width(this.props.width || 400)
                .height(this.props.width || 500)
                .color(this.props.color)
                .strokeColor(this.props.strokeColor)
                .tooltipContent(this.props.tooltipContent)
                // .centerRadius(0.5)
                .radiusScaleExponent(1)
                // .radiusScaleExponent(0.8)
                .excludeRoot(this.props.excludeRoot || false)
                // .minSliceAngle(0.001)
        }
    }

    render(){
        return (
            <div className="sunburst-chart" ref={this.ref}>
            </div>
        );
    }

};